"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _user = require("@/api/user");
var _marketing = require("@/api/marketing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'detailUser',
  props: {
    userNo: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      tableData: [],
      dialogUserDetail: false,
      userDetailData: {},
      tabsVal: '0',
      paginationData: {
        page: 1,
        limit: 10,
        type: 0,
        userId: '',
        total: 10
      }
    };
  },
  watch: {
    tabsVal: function tabsVal(val) {
      this.paginationData.userId = this.userNo;
      this.paginationData.page = 1;
      this.paginationData.type = val - 1;
      if (val != 0) {
        this.getListData();
        // if (this.paginationData.type == '1') {
        //   this.getIntergralList();
        // } else {
        //   this.getListData();
        // }
      }
    }
  },
  methods: {
    getNewList: function getNewList() {
      if (this.paginationData.type == '1') {
        this.getIntergralList();
      } else {
        this.getListData();
      }
    },
    handleSizeChange: function handleSizeChange(val) {
      this.paginationData.limit = val;
      this.getNewList();
    },
    pageChange: function pageChange(val) {
      this.paginationData.page = val;
      this.getNewList();
    },
    handleClose: function handleClose() {
      this.dialogUserDetail = false;
      this.tabsVal = '0';
    },
    getIntergralList: function getIntergralList() {
      var _this = this;
      (0, _marketing.integralListApi)({
        limit: this.paginationData.limit,
        page: this.paginationData.page
      }, {
        uid: this.paginationData.uid
      }).then(function (res) {
        _this.tableData = res.list;
        _this.paginationData.total = res.total;
      });
    },
    getListData: function getListData() {
      var _this2 = this;
      (0, _user.infobyconditionApi)(this.paginationData).then(function (res) {
        _this2.tableData = res.list;
        _this2.paginationData.total = res.total;
      });
    },
    getUserDetail: function getUserDetail(id) {
      var _this3 = this;
      (0, _user.topdetailApi)({
        userId: id
      }).then(function (res) {
        _this3.userDetailData = res.user;
      });
    }
  }
};